import { render, staticRenderFns } from "./AssignmentRoomResults.vue?vue&type=template&id=60263527&"
import script from "./AssignmentRoomResults.vue?vue&type=script&lang=js&"
export * from "./AssignmentRoomResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports